<template>
  <div class="card-container">
    <div v-if="noResult">
      <no-result-error :term="searchTerm"></no-result-error>
    </div>
    <div v-else>
      <div class="uk-width-1-1 error-card uk-flex uk-flex-center" uk-grid>
        <errors :error="error.status" :large="false"></errors>
      </div>
    </div>
  </div>
</template>
<script>
  import Errors from './../content-error/errors'
  import NoResultError from './no-result-error'

  export default {
    name: 'search-error',
    props: ['error', 'noResult', 'searchTerm'],
    components: {
      Errors,
      NoResultError
    }
  }
</script>

<style lang="scss" scoped>
  .card-container {
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    padding: 5px;
    margin-bottom: 10px;

    &:hover {
      background-color: #ffffff;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.3);
    }
  }

  .error-card {
    margin: auto;
  }
</style>
